import * as React from "react";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { FinancialAdvice } from "../../../Common/PaymentsIn/FinancialAdvice";
import { processTypeEnum } from "../../../Common/Resource/Contents";
import IncomeRequired from "../../../Common/SIPP/IncomePaymentDetails/IncomeRequired";
import RegularIncomePayment from "../../../Common/SIPP/IncomePaymentDetails/RegularIncomePayment";
import { incomePaymentDetailsLabels, incomePaymentDetailsMessages } from "../../Resource/Contents";
import { ClientDetails } from "./ClientDetails";
import { PensionDetails } from "./PensionDetails";
import { ChooseAssetsToSell } from "../../../Common/SIPP/DrawdownDetails/ChooseAssetsToSell";
import { MoneyDisplayHelper } from "../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import BankDetails from "./BankDetails";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { MoneyHelper } from "../../../../../../Shared/Common/MoneyHelper";
import { ChooseAssetsToSellTable } from "../../../Common/SIPP/DrawdownDetails/ChooseAssetsToSellTable";
import { DrawdownType } from "../../../../../../../Wrap/Constants/Enums/Drawdown/DrawdownType";
import { ChooseAssetsToSellFor } from "../../../Common/SIPP/DrawdownDetails/Resource/Contents";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { SubAccountTypeHelper } from "../../../Common/Helpers/SubAccountTypeHelper";
import {
    getSellableAssets,
    getUpdatedAssetsToSell,
} from "../../../Common/SIPP/DrawdownDetails/Helper/DrawdownDetailHelper";
import { ChooseAssetsToSellAssets } from "../../../Common/SIPP/DrawdownDetails/Store/DrawdownCalculationStoreStatic";
import { CappedFlexiSection } from "../../../Common/SIPP/IncomePaymentDetails/CappedFlexiSection";
import { isNullOrEmpty } from "../../../../../../../react-core/Utils/Arrays";
import { ProcessType } from "../../../../../../Shared/IST/Resource/Content";
import { getAssetsToSellTotalForIncomeFromIncome } from "../../../Common/SIPP/IncomePaymentDetails/Helper/IncomePaymentHelper";
import { Alert } from "../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../Shared/Entities/Constants/AlertConstants";
import { User } from "../../../../../../../Wrap/Models/Models/User/User";
import { UserStore } from "../../../../../Stroes/Variable";
import { GENERIC_RESTRICTIONS_MESSAGE } from "../../../../../../Shared/Common/UserMessages";

interface IIncomePaymentDetailsProps extends IProcessComponentProps {
    type: SubAccountType;
    data: any;
    extraInfo?: any;
    disableWithdraw?: boolean;
}

interface IIncomePaymentDetailsState {
    isIncomeRequired: boolean;
    assets: ChooseAssetsToSellAssets[];
    userInfo: User;
}

export class IncomePaymentDetails extends ProcessComponent<IIncomePaymentDetailsProps, IIncomePaymentDetailsState> {
    constructor(props: any) {
        super(props);
        const income = this.props.data?.DrawdownIncomeAmendmentInstruction?.Income;
        this.state = {
            userInfo: UserStore.getUserInfo(),
            assets: null,
            isIncomeRequired:
                income?.GrossIncomePerPayment?.Amount > 0 || income?.GrossIncomePerPaymentFromPension?.Amount > 0,
        };
    }

    private getSellableAssets = () => {
        const params = getQueryParameters();
        const hierarchyId = params["hierarchyid"];
        SubAccountTypeHelper.getSubAccountHierarchyId(hierarchyId, SubAccountType.Npr, (subAccountHierarchyId) => {
            getSellableAssets(this.props.type, hierarchyId, subAccountHierarchyId, (data) => {
                const updateAssets = getUpdatedAssetsToSell([], 0, data);
                this.setState({ assets: updateAssets });
            });
        });
    };

    componentDidMount() {
        super.componentDidMount();
        this.getSellableAssets();

        if (!isNullOrEmpty(this.props.data?.DrawdownIncomeAmendmentInstruction?.IncomeDisinvestmentAllocations)) {
            this.props.onChange({ IsAcrossAllAssets: false });
        }
    }

    private handleChange(changes, key?: string) {
        const { data, onChange } = this.props;
        this.onDataChange(
            (changes) => {
                this.onDataChange(onChange, changes, data, "DrawdownIncomeAmendmentInstruction");
            },
            changes,
            data?.DrawdownIncomeAmendmentInstruction,
            key
        );
    }

    public render(): JSX.Element {
        const { data, onChange, extraInfo } = this.props;

        let restrictedMessage = "An account with suspended or restricted activities cannot setup income payment";

        if (this.state.userInfo != null && this.state.userInfo.IsAdviser) {
            restrictedMessage = GENERIC_RESTRICTIONS_MESSAGE;
        }

        return (
            <div className="col-md-10 col-12">
                <h2>Income payment details</h2>

                {this.props.disableWithdraw && <Alert alertType={AlertType.Error} message={restrictedMessage} />}
                <div>
                    <FinancialAdvice
                        data={data?.DrawdownIncomeAmendmentInstruction}
                        onChange={(v) => {
                            this.handleChange(v);
                        }}
                        onRef={(ref) => this.appendChild(ref)}
                    />
                    <hr />
                    <ClientDetails data={data?.DrawdownIncomeAmendmentCalucations} />
                    <PensionDetails data={data?.DrawdownIncomeAmendmentCalucations} />
                    <RadiosEditor
                        cssWrapper="rg-inline mb-16"
                        label={incomePaymentDetailsLabels.incomeRequired}
                        selected={this.state.isIncomeRequired}
                        options={[true, false]}
                        getText={(v) => (v ? "Yes" : "No")}
                        onChange={(v) => {
                            this.setState({ isIncomeRequired: v });
                            if (!v) {
                                this.onDataChange(
                                    (changes) =>
                                        this.onDataChange(
                                            onChange,
                                            changes,
                                            data,
                                            "DrawdownIncomeAmendmentInstruction"
                                        ),
                                    { Income: null },
                                    data.DrawdownIncomeAmendmentInstruction
                                );
                                this.handleChange({ IncomePaymentAllocations: [] }, "Income");
                            }
                        }}
                    />
                    {this.state.isIncomeRequired && (
                        <>
                            <IncomeRequired
                                data={data?.DrawdownIncomeAmendmentInstruction?.Income}
                                onChange={(changes) => {
                                    this.handleChange(changes, "Income");
                                }}
                                labels={incomePaymentDetailsLabels}
                                messages={incomePaymentDetailsMessages}
                                onRef={(ref) => this.appendChild(ref)}
                                processType={processTypeEnum.GadReview}
                                drawdownType={extraInfo?.DrawdownType}
                                pensionTransfer={[]}
                                pensionBase={null}
                                isITFC={false}
                            />
                            {data?.DrawdownIncomeAmendmentInstruction?.Income?.TargetSpecificArrangements &&
                                extraInfo?.Drawdowntype === DrawdownType.Capped && (
                                    <CappedFlexiSection
                                        data={data?.DrawdownIncomeAmendmentInstruction?.ExistingArrangements}
                                        onChange={(changes) => {
                                            this.handleChange(changes, "ExistingArrangements");
                                        }}
                                        income={data?.DrawdownIncomeAmendmentInstruction?.Income}
                                        onIncomeChange={(changes) => this.handleChange(changes, "Income")}
                                        showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                                        onRef={(ref) => this.appendChild(ref)}
                                        drawdownType={extraInfo?.DrawdownType}
                                    />
                                )}
                            <RegularIncomePayment
                                data={data?.DrawdownIncomeAmendmentInstruction?.Income}
                                onChange={(changes) => {
                                    this.handleChange(changes, "Income");
                                }}
                                labels={incomePaymentDetailsLabels}
                                messages={incomePaymentDetailsMessages}
                                shouldHidePaymentMethod={true}
                                onRef={(ref) => this.appendChild(ref)}
                                drawdownType={extraInfo?.DrawdownType}
                                pensionBase={null}
                                processType={processTypeEnum.GadReview}
                                isITFC={false}
                            />
                            <ChooseAssetsToSell
                                data={{ IsAcrossAllAssets: data?.IsAcrossAllAssets }}
                                onChange={(value) => this.onDataChange(this.props.onChange, value, data)}
                                sectionHeader={`Choose assets to sell to pay income (${MoneyDisplayHelper.FromatMoneyDisplay(
                                    getAssetsToSellTotalForIncomeFromIncome(
                                        data?.DrawdownIncomeAmendmentInstruction?.Income
                                    ),
                                    MoneyHelper.getDefaultCurrency()
                                )})`}
                                onRef={(ref) => this.appendChild(ref)}
                                processType={processTypeEnum.GadReview}
                                tableKey={"IncomeDisinvestmentAllocations"}
                            />
                            {!data.IsAcrossAllAssets && (
                                <ChooseAssetsToSellTable
                                    data={data?.DrawdownIncomeAmendmentInstruction?.IncomeDisinvestmentAllocations}
                                    tableData={this.state.assets}
                                    modelData={{ DrawdownType: DrawdownType.Capped }}
                                    reason={ChooseAssetsToSellFor.Income}
                                    onRef={(ref) => this.appendChild(ref)}
                                    onChange={(v) => {
                                        this.onDataChange(
                                            (changes) =>
                                                this.onDataChange(
                                                    onChange,
                                                    changes,
                                                    data,
                                                    "DrawdownIncomeAmendmentInstruction"
                                                ),
                                            { IncomeDisinvestmentAllocations: v },
                                            data.DrawdownIncomeAmendmentInstruction
                                        );
                                    }}
                                    processType={ProcessType.GadReview}
                                    gadReviewtotalValue={getAssetsToSellTotalForIncomeFromIncome(
                                        data?.DrawdownIncomeAmendmentInstruction?.Income
                                    )}
                                />
                            )}
                            <hr />
                            <BankDetails
                                data={data?.DrawdownIncomeAmendmentInstruction?.Income?.IncomePaymentAllocations || []}
                                onChange={(value) => {
                                    this.handleChange({ IncomePaymentAllocations: value }, "Income");
                                }}
                                onRef={(ref) => this.appendChild(ref)}
                                allBankAccounts={extraInfo?.AllBankAccounts}
                            />
                        </>
                    )}
                </div>
            </div>
        );
    }
}
